// extracted by mini-css-extract-plugin
export default {"CanceledStatus":"_CanceledStatus--OeFDJ","Divider":"_Divider--zVtiq","CancelButtonContainer":"_CancelButtonContainer--sa4Wo"};